import userService from '../services/user.service';
import { ThunkAction } from './common.actionTypes';
import {
  FETCH_RECENTLY_VIEWED,
  FetchRecentlyViewedAction,
} from './recentlyViewed.actionTypes';
import { PaginationRequest } from '@kimuno/api-sdk/lib/types/common';

export function fetchRecentlyViewed(
  pagination: PaginationRequest
): ThunkAction<FetchRecentlyViewedAction> {
  const payload = {
    pagination
  };
  return async (dispatch) => {
    dispatch({ type: FETCH_RECENTLY_VIEWED.START, payload });
    userService
      .getRecentlyViewed(pagination)
      .then((result) =>
        dispatch({ type: FETCH_RECENTLY_VIEWED.SUCCESS, payload, result })
      )
      .catch((error) =>
        dispatch({ error, type: FETCH_RECENTLY_VIEWED.ERROR, payload })
      );
  };
}
